import { GTAO_NUMBER_SETTINGS } from "flavr-common";
export { GTAO_NUMBER_SETTINGS };
export const GTAO_PREFERENCE_SCHEMA = Object.assign(Object.assign({ useGtao: { type: "boolean", default: true } }, Object.fromEntries(Object.entries(GTAO_NUMBER_SETTINGS).map(([key, settings]) => [key, { type: "number", default: settings.default }]))), { gtaoScreenSpaceRadius: { type: "boolean", default: false } });
export function isGtaoPreference(key) {
    return Object.prototype.hasOwnProperty.call(GTAO_PREFERENCE_SCHEMA, key);
}
export function getGtaoSettings(preferences) {
    var _a, _b;
    const settings = {};
    for (const key of Object.keys(GTAO_NUMBER_SETTINGS)) {
        const config = GTAO_NUMBER_SETTINGS[key];
        const value = (_a = preferences === null || preferences === void 0 ? void 0 : preferences.getNumberPreferredValue(key, config.default)) !== null && _a !== void 0 ? _a : config.default;
        const bounded = Number.isFinite(value) ? Math.max(config.min, Math.min(config.max, value)) : config.default;
        settings[key] = config.step === 1 ? Math.round(bounded) : bounded;
    }
    return Object.assign(Object.assign({}, settings), { gtaoScreenSpaceRadius: (_b = preferences === null || preferences === void 0 ? void 0 : preferences.getBooleanPreferredValue("gtaoScreenSpaceRadius", false)) !== null && _b !== void 0 ? _b : false });
}
